import {WheelType} from './WheelType';

export type TireSetFormType = {
  assignMechanic: string;
  storedLocation: string;
  storedUntil: string;
  categoryId: string;
  isReplacement: boolean;
  numberOfTires: number;
  wheels: WheelType[];
  note: string;
  contactPerson: {
    name: string;
    phoneNumber: {
      countryCode: string;
      number: number;
      prefix: string;
    };
    email: string;
  };
  destinationBranchId?: string;
  neededAtDate?: Date;
  neededAtTime?: string;
  requestNote?: string;
  tireSetRequestEnabled?: boolean;
};
